"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const disabled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-disabled` : '') + (description ? ` desc-disabled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-disabled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-disabled"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_15522_6575)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 .25a11.75 11.75 0 1 1 0 23.5 11.75 11.75 0 0 1 0-23.5Zm0 1.5a10.25 10.25 0 1 0 0 20.5 10.25 10.25 0 0 0 0-20.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.65 4.36 4.06 18.95l-.07.08c-.3.38-.32.85-.06 1.11.3.3.82.24 1.2-.13L19.7 5.42l.07-.08c.3-.38.32-.85.06-1.11-.29-.29-.82-.24-1.2.13Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_15522_6575"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
var _default = exports.default = disabled;